import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${space['space-200']};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-variant='card'] {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    gap: ${space['space-500']};
    padding: ${space['space-500']};
    border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
    border-radius: ${size.radius['radius-lg']};
    font-size: ${fonts.size.base};
    line-height: ${primitives.typography.lineHeight.normal};
    transition: border-color 0.15s ease;
  }

  /* Keeps the row height steady when the thicker selected border lands. */
  &[data-variant='card'][data-selected='true'] {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.selected};
    padding: calc(${space['space-500']} - ${size.stroke['stroke-default']});
  }

  &[data-variant='card'] > input {
    margin: ${space['space-300']};
  }
`;

export const RadioControl = styled.input`
  appearance: none;
  box-sizing: border-box;
  width: ${size.icon['icon-md']};
  height: ${size.icon['icon-md']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.secondary};
  border-radius: ${size.radius['radius-full']};
  margin: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;

  &:checked {
    border-color: ${semantic.border.selected};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: ${space['space-100']};
    left: ${space['space-100']};
    width: 14px;
    height: 14px;
    border-radius: ${size.radius['radius-full']};
    background: ${semantic.bg.primary};
  }

  &[data-error='true'],
  &[data-error='true']:checked {
    border-color: ${semantic.border.danger};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
